import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import { useContext } from "react";
import { ConfirmationDialogProps } from "./ConfirmationDialog.types";
import PspButton from "../pspButton/PspButton";

export default function ConfirmationDialog({
  title,
  message,
  isOpen,
  onCancel,
  onConfirm,
  confirmButtonText,
  cancelButtonText,
  messageString,
  titleString,
}: ConfirmationDialogProps) {
  const { lang } = useContext(PspContext);

  return (
    <Dialog open={isOpen}>
      <DialogSurface>
        <DialogBody className="mb-4">
          <DialogTitle>
            {title ? translate(title, lang) : titleString}
          </DialogTitle>
          <DialogContent>
            {message ? translate(message, lang) : messageString}
          </DialogContent>
        </DialogBody>
        <DialogActions>
          <button className="w-0 h-0" />
          <div className="flex flex-row justify-end w-full gap-2">
            <DialogTrigger>
              <PspButton appearance="secondary" onClick={onCancel}>
                {translate(cancelButtonText ?? "cancel", lang)}
              </PspButton>
            </DialogTrigger>
            <PspButton appearance="primary" onClick={onConfirm}>
              {translate(confirmButtonText ?? "confirm", lang)}
            </PspButton>
          </div>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}
